import { GitHub } from '@mui/icons-material';
import React, { useState } from 'react';
import GitHubCalendar from 'react-github-calendar';
import ReactTooltip from 'react-tooltip';
import { MenuItem } from '@mui/material';
import colors from '@/styles/colors';
import { StyledContainer, StyledTextField } from './styles';
import { getUpdatedYears } from '@/utils/commonFunctions';

export default function Contribution() {
  const [selectedYear, setSelectedYear] = useState(null);
  const years = getUpdatedYears();

  const handleUserInput = ({ target: { value } }) => setSelectedYear(value);

  return (
    <StyledContainer className="px-4 py-5 mx-auto">
      <div className="flex items-center mb-4 w-full">
        <GitHub className="w-10 inline-block mr-4" color={colors.lighter} fontSize="large" />
        <h1 className="sm:text-4xl text-3xl font-medium title-font text-white">Github Contributions</h1>
      </div>
      <div className="w-full mb-4">
        <StyledTextField id="selectedYear" select label="Contribution Year" value={selectedYear ?? ''} onChange={handleUserInput} margin="dense">
          {years?.length > 0
            ? years.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            : null}
        </StyledTextField>
      </div>
      <GitHubCalendar
        username="papuruth"
        hideColorLegend
        blockSize={18}
        blockRadius={0}
        blockMargin={2}
        labels={{ totalCount: `{{count}} contributions in ${selectedYear ?? 'the last year'}` }}
        year={selectedYear ?? 'last'}
      >
        <ReactTooltip html />
      </GitHubCalendar>
    </StyledContainer>
  );
}
